<template>
  <email-form-modal
    :modal-id="modalId"
    :title="modalTitle"
    :help-text="helpText"
    :initial-emails="initialEmailsForForm"
    :allow-empty-email-list="allowEmptyEmailList"
    :request="submitRequest"
    @success="onSuccess"
  >
    <template
      v-if="isBulkSelection"
      #fields="{ processing }"
    >
      <b-row class="mb-3">
        <b-col>
          <b-form-checkbox
            v-model="emailAssignedTechnicians"
            :disabled="processing"
          >
            Email each work order PDF to its assigned technician
          </b-form-checkbox>
          <small
            v-if="emailAssignedTechnicians"
            class="form-text text-muted d-block"
          >
            Optional addresses below are copied on every message (for example, an office CC).
            Leave them blank to send only to assigned technicians.
          </small>
        </b-col>
      </b-row>
      <b-row
        v-if="emailAssignedTechnicians && workOrdersMissingAssignedEmail.length"
        class="mb-2"
      >
        <b-col>
          <b-alert
            show
            variant="warning"
          >
            These selected work orders have no assigned technician email and cannot be sent in this mode:
            {{ workOrdersMissingAssignedEmail.map((wo) => wo.number || `#${wo.id}`).join(', ') }}
          </b-alert>
        </b-col>
      </b-row>
    </template>
  </email-form-modal>
</template>

<script>
import EmailFormModal from '@/components/shared/EmailFormModal.vue';

function uniqueStrings(values) {
  return [...new Set((values || []).map((v) => String(v).trim()).filter((v) => v.length > 0))];
}

export default {
  name: 'WorkOrdersEmailModal',
  components: {
    EmailFormModal,
  },
  props: {
    value: Object,
    email: String,
    filters: {
      type: Object,
      default: () => ({}),
    },
    workOrders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalId: 'work-order-email-modal',
      emailAssignedTechnicians: false,
    };
  },
  computed: {
    isBulkSelection() {
      return Array.isArray(this.workOrders) && this.workOrders.length > 0;
    },
    modalTitle() {
      if (this.isBulkSelection) {
        return `Email ${this.workOrders.length} Work Orders`;
      }
      return `Email Work Order ${this.value?.number || ''}`;
    },
    helpText() {
      if (!this.isBulkSelection) {
        return undefined;
      }
      return 'Enter one or more addresses, or choose assigned technicians above.';
    },
    initialEmailsForForm() {
      return this.email ? [this.email] : null;
    },
    allowEmptyEmailList() {
      return this.isBulkSelection && this.emailAssignedTechnicians;
    },
    workOrdersMissingAssignedEmail() {
      if (!this.emailAssignedTechnicians) {
        return [];
      }
      return this.workOrders.filter((wo) => !(wo.assigned_to && String(wo.assigned_to.email || '').trim()));
    },
  },
  watch: {
    isBulkSelection(isBulk) {
      if (!isBulk) {
        this.emailAssignedTechnicians = false;
      }
    },
  },
  methods: {
    onSuccess(workOrder) {
      if (this.value) {
        this.$emit('input', workOrder);
      }
      this.$emit('email-sent', workOrder);
    },
    submitRequest(payload) {
      if (this.isBulkSelection) {
        return this.submitBulkRequest(payload);
      }
      return this.$workOrdersAPI.email(this.value.id, payload);
    },
    submitBulkRequest(payload) {
      const emails = uniqueStrings(payload.emails);
      return this.$workOrdersAPI.bulkEmailWorkOrders(
        {},
        {
          work_order_ids: this.workOrders.map((wo) => Number(wo.id)),
          emails,
          email_assigned_technicians: this.emailAssignedTechnicians,
        },
      );
    },
  },
};
</script>
